import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "alert-hint mb-3"
};
const _hoisted_2 = {
  class: "rounded-lg bgColor file-list"
};
const _hoisted_3 = {
  class: "flex justify-between pl-4 pr-4"
};
const _hoisted_4 = {
  class: "flex items-center gap-3"
};
const _hoisted_5 = {
  key: 0,
  class: "absolute -top-2 -left-0"
};
const _hoisted_6 = {
  class: "fileItem"
};
const _hoisted_7 = {
  class: "title truncate"
};
const _hoisted_8 = {
  class: "desc"
};
const _hoisted_9 = {
  class: "media-list grid grid-cols-4 gap-2"
};
const _hoisted_10 = ["src", "alt", "aria-label", "onClick"];
const _hoisted_11 = {
  class: "rounded-lg bgColor text-[#86909C] p-4 mt-3"
};
const _hoisted_12 = {
  class: "text-[#1D2129]"
};
import { ref, onMounted, computed, inject } from 'vue';
import BatchBannedWordCheck from './BatchBannedWordCheck.vue';
import useAppStore from '@views/app.store';
import { getMediaType } from '@/views/main/api/media';
import useMedia from '@/views/main/components/media/hooks/useMedia';
import DraggableWrapper from '@views/home/components/preview-dialog/DraggableWrapper.vue';
import Tab1Dialog from './Tab1Dialog.vue';
import ArticleHandle from '../components/ArticleHandle.vue';
export default /*@__PURE__*/Object.assign({
  name: 'MediaCreateTab1'
}, {
  __name: 'Tab1',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['refresh'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const appStore = useAppStore();
    const useCount = computed(() => {
      const list = availableFiles.value.filter(file => {
        return file.authoritativeMediaId;
      });
      return list.length * 400;
    });
    const mediaOptions = ref([]);
    const {
      getStatus
    } = useMedia();
    const availableFiles = inject('availableFiles');
    const tab1DialogRef = ref();
    const approvalStatusTip = computed(() => {
      const approval = getStatus(props.data.userInfo.AuditStatus);
      return approval?.tip;
    });
    const approvalStatusAlias = computed(() => {
      const approval = getStatus(props.data.userInfo.AuditStatus);
      return approval?.alias || approval?.label || '温馨提示：';
    });
    const clickBatchSetting = () => {
      tab1DialogRef.value.openDialog();
    };
    const handleSure = async data => {
      availableFiles.value.forEach(item => {
        item.authoritativeMediaId = data.ItemID;
      });
    };
    const selectMedia = (item, data) => {
      if (item.authoritativeMediaId != data.ItemID) {
        item.authoritativeMediaId = data.ItemID;
      } else {
        item.authoritativeMediaId = '';
      }
    };
    const handleRenderData = data => {
      return {
        type: 'card',
        title: data.title,
        content: data.content
      };
    };
    onMounted(async () => {
      const postData = {
        itemType: props.data.value
      };
      try {
        const e = await getMediaType(postData);
        mediaOptions.value = e.data;
      } catch (e) {
        // 处理错误
      }
    });
    __expose({
      useCount
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createTextVNode(_toDisplayString(approvalStatusAlias.value) + "： ", 1), _createElementVNode("span", null, _toDisplayString(approvalStatusTip.value), 1)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "flex items-center gap-2"
      }, [_createElementVNode("div", {
        class: "text-[#1D2129] font-medium"
      }, "设置发布媒体"), _createElementVNode("div", {
        class: "text-[#86909C]"
      }, "单平台发布消耗400点权益")], -1)), _createElementVNode("div", _hoisted_4, [_createVNode(BatchBannedWordCheck), _createVNode(_component_el_button, {
        link: "",
        type: "primary",
        onClick: clickBatchSetting
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 批量设置媒体 ", -1)]))]),
        _: 1
      })])]), _createVNode(_component_el_row, {
        class: "pl-4 pr-4 pb-4",
        gutter: 12
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFiles), (file, index) => {
          return _openBlock(), _createBlock(_component_el_col, {
            class: "mt-2 relative",
            key: index,
            span: 8
          }, {
            default: _withCtx(() => [file.bannedWords ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(ArticleHandle, {
              data: file,
              onRefresh: _cache[0] || (_cache[0] = $event => emits('refresh'))
            }, null, 8, ["data"])])) : _createCommentVNode("", true), _createVNode(DraggableWrapper, {
              renderData: handleRenderData(file)
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createTextVNode(_toDisplayString(file.fileTitle) + " ", 1), _createElementVNode("div", _hoisted_8, _toDisplayString(file.authoritativeMediaId ? '本次发布1个平台，预计400点' : '请选择要发布的平台'), 1)]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaOptions.value, (item, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "relative"
                }, [_createElementVNode("img", {
                  class: _normalizeClass(["media-item", {
                    'is-active': file.authoritativeMediaId == item.ItemID
                  }]),
                  src: require('@/assets/images/' + item.ItemIco),
                  alt: item.Title,
                  "aria-label": `选择媒体: ${item.Title}`,
                  onClick: $event => selectMedia(file, item)
                }, null, 10, _hoisted_10)]);
              }), 128))])])]),
              _: 2
            }, 1032, ["renderData"])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_12, "预计消耗权益点：" + _toDisplayString(useCount.value) + "点", 1), _createTextVNode(" （当前可用点数：" + _toDisplayString(_unref(appStore).surplusNum) + "点） ", 1)]), _cache[3] || (_cache[3] = _createElementVNode("div", null, "温馨提示：一篇文稿只能选择一个权威媒体", -1))]), _createVNode(Tab1Dialog, {
        ref_key: "tab1DialogRef",
        ref: tab1DialogRef,
        mediaOptions: mediaOptions.value,
        onClickSure: handleSure
      }, null, 8, ["mediaOptions"])]);
    };
  }
});